
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salem",
      function () {
        return require("private-next-pages/salem/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salem"])
      });
    }
  